var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2633 7.99977C17.2633 8.1945 17.1455 8.45325 17.026 8.57896L10.2891 15.7372C9.97457 16.0624 9.46498 16.1 9.09843 15.7701C8.77065 15.4749 8.76242 14.8996 9.06553 14.5791L14.4733 8.84209L0.842047 8.84209C0.376812 8.84209 -5.78172e-07 8.46497 -6.13847e-07 8.00004C-6.49545e-07 7.53481 0.37712 7.158 0.842047 7.158L14.4733 7.15799L9.06553 1.42096C8.76243 1.10053 8.78386 0.539215 9.09843 0.230262C9.43032 -0.0960455 9.97957 -0.0669699 10.2891 0.263157L17.026 7.42112C17.2239 7.61526 17.26 7.80211 17.2633 7.99977Z",
    fill: "#004887"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientLinkIcon);
export default __webpack_public_path__ + "static/media/patient-link-icon.a946928d1517bcf63214c788bf4d44f4.svg";
export { ForwardRef as ReactComponent };